import { Rule, AllowedTriggerField, Action } from './types';
import { Field, FieldTypes } from 'hellospa/components/editor/types';
import { unreachable } from 'hellospa/ts-utils';


export function isAllowedFieldType(type: Field['type']): type is AllowedTriggerField {
  switch (type) {
    case FieldTypes.Text:
    case FieldTypes.Checkbox:
    case FieldTypes.Dropdown:
    case FieldTypes.Radio:
      return true;
    default:
      return false;
  }
}

type RuleLocations = 'all' | 'triggers' | 'actions'
export function getFieldIdsFromRules(allFields: Field[], rules: Rule[], type: RuleLocations = 'all'): string[] {
  const allRulesActionIds = rules
    .flatMap((rule) => rule.actions)
    .flatMap((action: Action) => {
      switch (action.type) {
        case 'change-field-visibility':
          return [action.fieldId];
        case 'change-group-visibility':
          return allFields
            .filter((f) => 'group' in f && f.group === action.groupId)
            .map((f) => f.id);
        default:
          unreachable(action);
          return [];
      }
    });

  const allRulesTriggerIds = rules
    .flatMap((rule) => rule.triggers.map((t) => t.id));

  if (type === 'triggers') {
    return allRulesTriggerIds;
  } else if (type === 'actions') {
    return allRulesActionIds;
  }

  return allRulesActionIds.concat(allRulesTriggerIds);
}
